const s=["xs","sm","md","lg","xl"];export{s as Breakpoints};
//# sourceMappingURL=model.js.map
